// src/pages/msp-inventory/components/reports/RefreshableSection.jsx
import React from "react";

// Wraps any chart/table/KPI section — dims + disables interaction while a
// range/filter change is being refetched, WITHOUT unmounting or blanking the
// previous data. This means switching a date range or toggle never shows a
// blank flash or causes the layout to jump; the old data just visibly fades
// and a small spinner appears until the new data replaces it.
const RefreshableSection = ({ refreshing, className = "", children }) => (
    <div className={`relative ${className}`}>
        <div className={refreshing ? "opacity-40 pointer-events-none transition-opacity" : "transition-opacity"}>
            {children}
        </div>
        {refreshing && (
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-6 h-6 border-2 border-gray-300 border-t-teal-500 rounded-full animate-spin" />
            </div>
        )}
    </div>
);

export default RefreshableSection;